const topNavigationBars = {
  TopNavigationBar: () =>
    import(
      /* webpackChunkName: "top-navigation-bar" */
      '../../components/top-navigation-bar/TopNavigationBar'
    ),
};

export default topNavigationBars;
